export default __webpack_public_path__ + "static/media/logo.1aa810a2.png";